<template lang="pug">
  .TheHeaderUserMenu.top-bar-user-data
    UserPicture.small-avatar
    SolidSortDownIcon.svg-icon.sort-down-icon
    ul.menu.vertical
      li
        router-link(
          to="/profile",
        ) User Dashboard
      li
        a(
          color="primary",
          @click.prevent="onClickLogout"
        ) Logout
</template>

<script>
import { mapActions } from 'vuex';
import UserPicture from 'Components/UserPicture/UserPicture';
import SolidSortDownIcon from 'images/svg-icons/solid-carrot.svg';

export default {
  name: 'TheHeaderUserMenu',
  components: {
    UserPicture,
    SolidSortDownIcon,
  },
  props: {
    isLoginPage: Boolean,
    isSignUpPage: Boolean,
    disabled: Boolean,
  },
  methods: {
    ...mapActions('login', [
      'logout',
    ]),
    onClickLogout() {
      this.logout();
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.top-bar-user-data
  display: flex
  position: relative
  padding: 15px 0
  align-items: center
  cursor: pointer
  @media screen and (max-width: 991px)
    display: none
  &.disabled
    pointer-events: none
    .sort-down-icon
      display: none
  &.is-social-register
    @media screen and (max-width: 767px)
      display: flex !important
      ::v-deep .menu
        display: none
  .sort-down-icon
    margin-left: 3px
    transition: all 0.3s ease-in-out
    position: relative
    top: 2px
    width: sizeInRem(6)
    height: sizeInRem(4)
    fill: $primary
  ul.vertical
    right: -5px
    top: 64px
    li > a
      line-height: 15px
  &:hover
    ul.vertical
      visibility: visible
      opacity: 1
      +mt(.2s)
      li
        z-index: 1
        pointer-events: auto
  .small-avatar
    width: 42px
    height: 42px
    font-size: 20px
    position: relative
    ::v-deep .img
      width: 100%
      height: 100%
    &:not(.is_image)
      box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.05)
      ::v-deep .img
        width: 18px
        height: 18px
</style>
